import {useTranslation} from "react-i18next";
import PropTypes from "prop-types";

import MoneyInput from "./MoneyInput";
import TextInput from "./TextInput";

import "./utils/Inputs.scss";

const PriceInput = ({
  label,
  procent,
  percentReadOnly = true,
  percentValue,
  onPercentChange,
  width = "8em",
  labelStyles,
  required = false,
  className = "",
  unit,
  //  question = null,
  ...props
}) => {
  const {t} = useTranslation();
  const roundedValue = procent ? parseFloat(procent).toFixed(2) : "";
  const displayedPercentValue = percentValue ?? roundedValue;
  const handlePercentChange = e => {
    const raw = e?.target?.value ?? "";
    const sanitized = String(raw)
      .replace(/[^0-9.,]/g, "")
      .replace(/(.*?)[.,](.*?)[.,].*/g, "$1.$2");
    onPercentChange?.(sanitized);
  };

  const handlePercentKeyDown = e => {
    if (percentReadOnly) return;
    const allowedControlKeys = new Set([
      "Backspace",
      "Delete",
      "Tab",
      "Escape",
      "Enter",
      "ArrowLeft",
      "ArrowRight",
      "Home",
      "End",
    ]);
    if (allowedControlKeys.has(e.key) || e.metaKey || e.ctrlKey) return;

    const isDigit = e.key >= "0" && e.key <= "9";
    const isSeparator = e.key === "." || e.key === ",";
    if (isDigit) return;
    if (isSeparator) {
      const current = String(displayedPercentValue ?? "");
      if (current.includes(".") || current.includes(",")) {
        e.preventDefault();
      }
      return;
    }
    e.preventDefault();
  };
  // const [field, meta] = useField(props)
  return (
    <div className="price_input aibl">
      <MoneyInput width={width} label={label} required={required} {...props} labelStyles={labelStyles} />
      {unit && (
        <div className="row gap5 aibl">
          <span>{t("for")}</span>
          <TextInput label="" name="measurUnit" width="4em" disabled tooltipMessage={unit} />
        </div>
      )}
      <div
        style={{
          display: "flex",
          // alignSelf: "center"
        }}
      >
        <input
          // value={procent || ""}
          // decimalsLimit={2}
          value={displayedPercentValue}
          autoComplete="off"
          readOnly={percentReadOnly}
          onChange={handlePercentChange}
          onKeyDown={handlePercentKeyDown}
          inputMode="decimal"
          pattern="[0-9]*[.,]?[0-9]*"
          className={className}
          style={{
            width: "4em",
            paddingRight: "0.5em",
            ...(percentReadOnly
              ? {}
              : {
                  background: "white",
                  opacity: 1,
                  filter: "none",
                }),
            // ...(props.readOnly ? {cursor: "default"} : {background: "white"}),
          }}
        />
        <span>%</span>
      </div>
    </div>
  );
};
PriceInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
  props: PropTypes.array,
  width: PropTypes.string,
  procent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  percentReadOnly: PropTypes.bool,
  percentValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onPercentChange: PropTypes.func,
};

export default PriceInput;
